// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { FormFilterType } from "../schema";

export function serialize_FormFilterType_internal(value: FormFilterType): unknown {
  return ((value: "MULTICHECKBOX" | "CHECKBOX" | "MULTISELECT" | "RANGE" | "RANGE_MIN"): unknown => {
    return value;
  })(value);
}
export function serialize_FormFilterType(obj: FormFilterType): string {
  return renderJsonWithNumbersAsBigint(serialize_FormFilterType_internal(obj));
}
export function deserialize_FormFilterType_internal(value: unknown): ParserResult<FormFilterType> {
  return ((value: unknown): ParserResult<"MULTICHECKBOX" | "CHECKBOX" | "MULTISELECT" | "RANGE" | "RANGE_MIN"> => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/FormFilterType]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "MULTICHECKBOX":
        return { success: true, value: "MULTICHECKBOX" };
      case "CHECKBOX":
        return { success: true, value: "CHECKBOX" };
      case "MULTISELECT":
        return { success: true, value: "MULTISELECT" };
      case "RANGE":
        return { success: true, value: "RANGE" };
      case "RANGE_MIN":
        return { success: true, value: "RANGE_MIN" };
      default:
        return { success: false, reason: `[#/components/schemas/FormFilterType]: '${value}' expected to be enum, one of 'MULTICHECKBOX, CHECKBOX, MULTISELECT, RANGE, RANGE_MIN'.` };
    }
  })(value);
}
export function deserialize_FormFilterType(str: string): ParserResult<FormFilterType> {
  return deserialize_FormFilterType_internal(parseJsonWithNumbersAsBigint(str));
}
